<div class="dropdown-menu d-block position-relative">
  <ng-content></ng-content>
</div>
